// Components
import Sidebar from '../../components/Sidebar';
import Form from './DeliveryCustomerInfo/Form';

function DeliveryCustomerInfo() {
  return (
    <div className="DeliveryCustomerInfo">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              <Form
                name={'ข้อมูลลูกค้าผูกสายส่ง'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeliveryCustomerInfo;
